import { createContext } from "react";
import { RootStore } from "./Root.store";

export const rootStoreContext = createContext({
  rootStore: new RootStore(),
});
